import { clsx } from "clsx";
import React from "react";
import { twMerge } from "tailwind-merge";

interface FlyoutContainerProps {
  flyoutRef: React.RefObject<HTMLDivElement>;
  isFlyoutOpen: boolean;
  children: React.ReactNode;
  isMobile: boolean;
  style: React.CSSProperties;
}

const FlyoutContainer: React.FC<FlyoutContainerProps> = ({
  flyoutRef,
  isFlyoutOpen,
  children,
  isMobile,
  style,
}) => {
  return (
    <div
      ref={flyoutRef}
      style={{
        ...style,
        position: "fixed",
        width: isMobile ? "100%" : "100%",
        maxWidth: isMobile ? "none" : "550px",
        minWidth: "320px", // Smallest standard screen width for mobile devices
        height: isMobile ? "100dvh" : "calc(100vh - 40px)",
        overflow: isMobile ? "auto" : "hidden",
        display: isFlyoutOpen ? "block" : "none",
        willChange: "transform", // Optimize for animations
      }}
      className={twMerge(
        clsx(
          "bg-[#f2f7fa] text-black shadow-lg rounded-none sm:rounded-lg relative",
          isMobile ? undefined : "w-[100%] max-w-[550px]",
          isFlyoutOpen ? "max-w-550px" : undefined
        )
      )}
    >
      {children}
    </div>
  );
};

export default FlyoutContainer;
